export var loanNickNameCacheKey = function (_a, LOAN_NICKNAME_URL) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType;
    return [LOAN_NICKNAME_URL, { accountId: accountId, accountIdType: accountIdType }];
};
//# sourceMappingURL=helpers.js.map